import { Subscriptions } from '@rails/actioncable'

let installed = false

// One consumer serves every cable-backed page in the bundle, so an exception
// raised inside the socket handler stops live updates app-wide until a reload.
// The client dispatches any message type it does not recognise as a channel
// payload -- `notify(identifier, 'received', message)` -- and those frames carry
// no identifier, so the callback lookup dereferences `undefined` and throws.
// Our server is AnyCable, whose protocol gains message types independently of
// this client, so drop such a frame instead of taking the socket down with it.
export default function installCableProtocolGuard() {
  if (installed) return
  installed = true

  const { notify } = Subscriptions.prototype

  Subscriptions.prototype.notify = function notifyIdentifiedSubscriptions(subscription, ...rest) {
    if (subscription == null) return []

    return notify.call(this, subscription, ...rest)
  }
}
